import setConsumerMailboxOperation from 'owa-service/lib/operation/setConsumerMailboxOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function createRequestBody(options) {
    var request = {
        Header: getJsonRequestHeader(),
        Options: options,
    };
    return request;
}
export default function setConsumerMailboxOptions(options) {
    var requestBody = createRequestBody(options);
    return setConsumerMailboxOperation(requestBody);
}
//# sourceMappingURL=setConsumerMailboxOptions.js.map